import { KSpan, KTooltip } from "kahuna-base-react-components"
import { useEffect, useState } from "react"

const TruncatedListWithTooltip = ({
  itemList,
  title,
  visibleItemCount,
  breakPointInPx,
  smallScreenVisibleItemCount,
  separateByComma,
  navigateOnItemClick,
  targetUrl,
  hideDelay
}: {
  itemList: string[]
  title?: string
  visibleItemCount: number
  breakPointInPx?: number
  smallScreenVisibleItemCount?: number
  separateByComma?: boolean
  navigateOnItemClick?: boolean
  targetUrl?: string
  hideDelay?: number
}) => {
  const [visibleCount, setVisibleCount] = useState<number>(visibleItemCount)
  const breakPoint = breakPointInPx || 1500
  const useCommaInTooltip = separateByComma || false
  const visibleItems = itemList?.slice(0, visibleCount)

  useEffect(() => {
    const handleResponsiveAction = () => {
      const width = window.innerWidth
      if (width < breakPoint && smallScreenVisibleItemCount) {
        setVisibleCount(smallScreenVisibleItemCount)
      } else {
        setVisibleCount(visibleItemCount)
      }
    }

    handleResponsiveAction()

    window.addEventListener("resize", handleResponsiveAction)

    return () => {
      window.removeEventListener("resize", handleResponsiveAction)
    }
  }, [])

  return (
    <div className="flex">
      <div className="rounded-[4px] bg-[#F7F7F7] flex items-center px-1 py-0.5 w-auto">
        <div className=" flex flex-row items-center pr-1">
          <KSpan
            text={title || ""}
            color="#111"
            fontSize={11}
            fontWeight={500}
            lineHeight="12px"
            letterSpacing="0.22px"
          />
        </div>
        <div className="flex flex-row gap-[3px] items-center">
          {visibleItems.map((item, index) => {
            return (
              <div
                key={`${item}-${index}`}
                className={`flex items-center rounded-[2px] py-0.5 ${navigateOnItemClick && "hover:bg-[#999]"}`}
                style={{
                  cursor: navigateOnItemClick ? "pointer" : "default"
                }}
                onClick={() => {
                  if (!navigateOnItemClick || !targetUrl) return
                  const url = targetUrl?.replace("<param>", item)
                  window.open(url, "_blank")
                }}
              >
                <KSpan
                  text={item ? `${item}${index !== visibleItems?.length - 1 ? ", " : ""}` : "-"}
                  color="#111"
                  fontSize={11}
                  fontWeight={500}
                  lineHeight="12px"
                  letterSpacing="0.22px"
                />
              </div>
            )
          })}
        </div>
        {itemList?.length > visibleCount && (
          <KTooltip
            backgroundColor="#000"
            position="bottom"
            height="auto"
            border="none"
            padding="0px"
            hideDelay={hideDelay}
            content={
              useCommaInTooltip ? (
                <div className="max-w-[250px] w-max px-[5px] py-[3px] flex flex-wrap gap-[3px] items-center">
                  {itemList?.slice(visibleCount, itemList.length).map((item, index) => {
                    return (
                      <div
                        key={`${item}-${index}`}
                        className="flex flex-row hover:bg-[#999] rounded-[2px]"
                        style={{
                          cursor: navigateOnItemClick ? "pointer" : "default"
                        }}
                        onClick={() => {
                          if (!navigateOnItemClick || !targetUrl) return
                          const url = targetUrl?.replace("<param>", item)
                          window.open(url, "_blank")
                        }}
                      >
                        <KSpan
                          text={
                            item
                              ? `${item}${
                                  index !== itemList.slice(visibleCount, itemList.length)?.length - 1 ? ", " : ""
                                }`
                              : "-"
                          }
                          fontSize={12}
                          fontWeight={500}
                          lineHeight="16px"
                          color="#FFF"
                        />
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div className="w-max flex flex-col gap-1 items-start p-[5px]">
                  {itemList.slice(visibleCount, itemList.length).map((item, index: number) => {
                    return (
                      <div
                        key={`${item}-${index}`}
                        className="flex flex-row items-center"
                        style={{
                          cursor: navigateOnItemClick ? "pointer" : "default"
                        }}
                        onClick={() => {
                          if (!navigateOnItemClick || !targetUrl) return
                          const url = targetUrl?.replace("<param>", item)
                          window.open(url, "_blank")
                        }}
                      >
                        <KSpan
                          key={`${item}-${index}`}
                          text={item}
                          fontSize={12}
                          fontWeight={500}
                          lineHeight="16px"
                          color="#FFF"
                        />
                      </div>
                    )
                  })}
                </div>
              )
            }
          >
            {" "}
            <div className="flex items-center">
              <KSpan
                text={`, (+${itemList?.length - visibleCount})`}
                color="#111"
                fontSize={11}
                fontWeight={500}
                lineHeight="12px"
                letterSpacing="0.22px"
              />
            </div>
          </KTooltip>
        )}
      </div>
    </div>
  )
}

export default TruncatedListWithTooltip